import * as React from 'react';
import { styles } from './styles';
import { cx } from 'emotion';
type Props = {} & React.HTMLProps<HTMLDivElement>;

class SinglePane extends React.Component<Props> {
  render() {
    const { className, ...props } = this.props;
    return (
      <div {...props} className={cx(className, styles.container)}>
        {this.props.children}
      </div>
    );
  }
}

export { SinglePane };
